(function () {
  const MOBILE_BREAKPOINT = 1024;
  let resizeTimer;
  let activeDropdown = null;
  let activeTab = null;
  let isMobile = false;
  let isMobileNavActive = false;

  $(document).ready(function () {
    setIsMobile();
    bindHandlers();

    $(window).on("resize", function () {
      const wasMobile = isMobile;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setIsMobile();
        if (wasMobile && !isMobile) {
          hideMobileNav();
        } else if (!wasMobile && isMobile) {
          resetDropdowns();
        }
        unbindHandlers();
        bindHandlers();
      }, 125);
    });
  });

  function setIsMobile() {
    isMobile = $(window).outerWidth() < MOBILE_BREAKPOINT;
  }

  function unbindHandlers() {
    $("[data-mobile-nav-trigger]").off("click");
    $("[data-dropdown-trigger]").off("click mouseenter");
    $("[data-tab-trigger]").off("click mouseenter focus");
  }

  function bindHandlers() {
    if (isMobile) {
      $("[data-mobile-nav-trigger]").on("click", handleMobileNavTrigger);
      $("[data-dropdown-trigger]").on("click", handleDropdownTrigger);
      $("[data-tab-trigger]").on("click", handleTabTrigger);
      $("[data-dropdown-close-trigger]").on("click", resetDropdowns);
      return;
    }

    $("[data-dropdown-trigger]").on("click mouseenter", handleDropdownTrigger);
    $("[data-tab-trigger]").on("mouseenter focus", handleTabTrigger);
  }

  function handleMobileNavTrigger() {
    if (isMobileNavActive) return hideMobileNav();
    return showMobileNav();
  }

  function showMobileNav() {
    $("body").css({ overflow: "hidden" });
    $("[data-mobile-nav-trigger]").addClass("active");
    $("[data-mobile-nav]").fadeIn().addClass("active");
    $(document).on("keyup", function (e) {
      if (e.keyCode === 27) {
        hideMobileNav();
      }
    });
    isMobileNavActive = true;
  }

  function hideMobileNav() {
    $("body").css({ overflow: "auto" });
    $("[data-mobile-nav-trigger]").removeClass("active");
    $("[data-mobile-nav]").removeClass("active").removeAttr("style");
    resetDropdowns();
    $(document).off("keyup");
    isMobileNavActive = false;
  }

  function handleTabTrigger(event) {
    event.stopPropagation();
    const id = $(event.target).attr("data-tab-trigger");
    setActiveTab(id, true);
  }

  function handleDropdownTrigger(event) {
    event.stopPropagation();
    const id = $(event.target).attr("data-dropdown-trigger");
    setActiveDropdown(id);
  }

  function resetDropdowns() {
    $("[data-dropdown-trigger]").removeClass("active");
    $("[data-dropdown]").removeClass("active").removeAttr("style").off("click");
    $(window).off("click");
    activeDropdown = null;
    resetTabs();
  }

  function resetTabs() {
    $("[data-tab-trigger]").removeClass("active");
    $("[data-tab]").removeClass("active").removeAttr("style");
    $("[data-tab-outlet]").empty();
    activeTab = null;
  }

  function setActiveTab(id, animate) {
    const $tab = $('[data-tab="' + id + '"]');
    const $tabTrigger = $('[data-tab-trigger="' + id + '"]');

    if (activeTab === id) {
      if (isMobile) {
        if (animate) {
          $tab.slideUp();
        } else {
          $tab.hide();
        }
        $tabTrigger.removeClass("active");
        activeTab = null;
      }

      return;
    }

    $("[data-tab-trigger]").removeClass("active").removeAttr("aria-selected");
    $tabTrigger.addClass("active").attr("aria-selected", true);

    if (isMobile) {
      if (animate) {
        $("[data-tab]").slideUp();
        $tab.slideDown();
      } else {
        $("[data-tab]").hide();
        $tab.show();
      }
    } else {
      $("[data-tab-outlet]").empty().append($tab.clone());
      $("[data-tab-outlet]")
        .find("[data-tab]")
        .css({ display: "grid" })
        .hide()
        .fadeIn();
    }

    activeTab = id;
  }

  function setActiveDropdown(id) {
    if (activeDropdown === id) return;

    resetDropdowns();

    const $dropdownTrigger = $('[data-dropdown-trigger="' + id + '"]');
    const $dropdown = $('[data-dropdown="' + id + '"]');

    const tabId = $dropdown
      .find("[data-tab-trigger]")
      .first()
      .attr("data-tab-trigger");
    setActiveTab(tabId, false);

    if (!isMobile) {
      $dropdown.slideDown();
      // Close dropdown when clicking outside, but not inside
      $(window).on("click", function () {
        resetDropdowns();
      });
      $dropdown.on("click", function (e) {
        e.stopPropagation();
      });
    }

    $dropdownTrigger.addClass("active");
    $dropdown.addClass("active");

    activeDropdown = id;
  }
})();
